import { FC, useMemo } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import {
  Table,
  type IndicatorConfidentialityObjectType,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ReportIndicatorConfidentialityObjectsTable.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'report-indicator-confidentiality-objects-table',
);
addTranslations(translations);

const columnHelper = createColumnHelper<IndicatorConfidentialityObjectType>();

interface ReportIndicatorAlgorithmsTableProps {
  confidentialityObjects: IndicatorConfidentialityObjectType[];
}

export const ReportIndicatorConfidentialityObjectsTable: FC<
  ReportIndicatorAlgorithmsTableProps
> = (props) => {
  const { confidentialityObjects } = props;
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor('confidentialityDimension', {
        header: t('column.confidentialityDimension.header'),
      }),
      columnHelper.accessor(
        (rowData) =>
          t(
            `column.isPublicOrFictitious.${rowData.isPublic || rowData.isFictitious}`,
          ),
        {
          header: t('column.isPublicOrFictitious.header'),
          cell: (props) => props.renderValue(),
        },
      ),
    ],
    [t],
  );

  return (
    <Table
      name="indicator-confidentialityObjects"
      columns={columns}
      data={confidentialityObjects || EMPTY_DATA}
    />
  );
};

const EMPTY_DATA: any[] = [];
